import React from 'react';
import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    console.error(
      '[ErrorBoundary] caught render error:',
      error,
      info.componentStack
    );
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback />;
    }
    return this.props.children;
  }
}
